import React, { useEffect, useState } from "react";
import { Container, Row, Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const Setup = () => {
  const [isLoading, setIsLoading] = useState("true");

  const [searchParams] = useSearchParams();

  const install = async () => {
    try {
      setIsLoading(true);
      const code = searchParams.get("code");
      if (code) {
        const { data: res } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_INSTALL_URL}`,
          {
            params: { code },
          }
        );
        console.log(res);
        window.open(res.domain, "_self");
      }
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      console.log(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    install();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      style={{ height: "100vh" }}
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <Row>
        {isLoading && (
          <div className="d-flex flex-column justify-content-center align-items-center nav-loading-container">
            <div className="d-flex flex-row justify-content-center align-items-center">
              <Spinner animation="border" variant="primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </div>
        )}
      </Row>
    </Container>
  );
};

export default Setup;
